<template>


    <div class="content-wrap">
        <div class="table-responsive table-list">
            <DataTable v-model:selection="state.selectedRow" :value="state.gridRowData" selectionMode="multiple"
                dataKey="seq" paginator :rows="20" :rowsPerPageOptions="[10, 20, 50, 100, 200]" @rowSelect="onRowSelect">
                <template #empty>
                    <div class="center">데이터가 존재하지 않습니다.</div>
                </template>
                <Column>
                    <template #header>
                        <ElCheckbox v-model="allCheck"/>
                    </template>
                    <template #body="{ data }">
                        <ElCheckbox 
                        v-model="state.selectedRow" 
                        :value="data"
                        />
                    </template>
                    </Column>
                    <Column v-for="temp of state.gridColumn" 
                        :key="temp" 
                        :field="temp.field" 
                        :header="temp.headerName" 
                        sortable 
                        style="min-width: 250px">
                    </Column>
                </DataTable>
            </div>
        
            <!-- <div class="text-end py-3">
                <ElButton type="primary"  @buttonClick="deleteRow()">삭제</ElButton>
            </div> -->
        </div>

        <div class="text-end py-3">
            <ElButton type="primary" @buttonClick="deleteRow()">삭제</ElButton>
        </div>
</template>

<script setup>
import { reactive, onMounted, ref, computed } from 'vue'
import { useRouter } from "vue-router";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import vueRouterCmn from '@/js/vueRouterCmn';
import { useUserStore } from '@/store/user'
const userStore = useUserStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { tempoEdit, tempoList } from '@/api/tempo';

const router = useRouter();

onMounted(async () => {
   await getDataList()
})

const state = reactive({
    gridColumn: [
        { headerName: '메뉴명', field: "menu_nm" },
        { headerName: '제목', field: "title" },
        { headerName: '수정자', field: "user_nm" },
        { headerName: '수정일', field: "upd_dt" }
    ],
    gridRowData: [],
    selectedRow: [],
    searchParams: {
        title: '',
        page_count: 1,
        unit_count: 100000,
    }
})

const allCheck = computed({
    get() {
        return state.gridRowData.length === state.selectedRow.length;
    },
    set(newValue) {
        state.selectedRow = newValue ? state.gridRowData.map((item) => { return item }) : [];
    }
})

const getDataList = async () => {
    try {
        setIsLoading(true)
        const res = await tempoList(state.searchParams)
        state.gridRowData = res.rtn || []
    } catch (err) {
        console.log('/tempo/tempoList ERROR!! => ' + err)
        alert('api 에러 발생!!')
    } finally {
        setIsLoading(false)
    }
}


const deleteRow = async (data) => {
    if (confirm("선택하신 항목을 삭제 하시겠습니까?") == true) {
        let params = ""
        if (state.selectedRow && state.selectedRow?.length > 0) {
            let cnt = 0
            for (let rows of state.selectedRow) {
                    params = {
                        seq: rows.ims_seq || rows.seq,
                        tb_id: rows.tb_id,
                        ss_user_id: userStore.user.employeeId
                    };
                
                try {
                    setIsLoading(true)
                    const res = await tempoEdit(params)
                    if(res.code=== '0000') cnt += 1
                } catch (err) {
                    console.error('error', err)
                } finally {
                    setIsLoading(false)
                }
            }
            alert(cnt + '건 삭제완료했습니다.')
            getDataList() // 데이터 가져오기

        }
        else {
            alert('선택된 행이 없습니다.')
        }
    }
}

const onRowSelect = (param) => {
    console.log('param',param)
    // alert(param.data.td_id)
    if (param.type === 'row') {
        if (param.data.tb_id == 'cmp') {
            vueRouterCmn.routerPush('/cp/MCP_CR_003', { cp_seq: param.data.seq })
        } else if (param.data.tb_id == 'event') {
            vueRouterCmn.routerPush('/sm/MSM_SA_009', { ev_seq: param.data.seq })
        } else if (param.data.tb_id == 'lead') {
            vueRouterCmn.routerPush('/sm/MSM_SA_006', { ld_seq: param.data.seq })
        } else if (param.data.tb_id == 'mng') {
            vueRouterCmn.routerPush('/sh/MSH_SR_003', { mng_seq: param.data.seq })
        } else if (param.data.tb_id == 'sales_imsi') {
            vueRouterCmn.routerPush('/sr/MSR_SO_003', { ims_seq: param.data.ims_seq})
        }

    }
}    
</script>